import api from "@/services/api.service";
import {} from 'vuelidate/lib/validators'

export default {
    name: 'edit',
    components: {},
    props: [],
    data() {
        return {
            caption: "Contact Edit",
            campaigns: [],
            formField: {first_name: '', last_name: '', personal_email: '', personal_phone: '', residential_address: '',
            middle_name:'', business_phone:'',business_email:'',residential_city:'',residential_state:'',residential_zipcode:'',
            business_address:'',business_city:'',business_state:'',business_zipcode:'',job_title:'',year_of_birth:'',dob:'',
            retirement_year:'',retired:'',income:'',tcp_saving:'',qualified_saving:'',non_qualified_saving:'',life_insurance:'',facebook:'',linked_in:'',
            twitter:'',other:'',status:'',hourly:'',date_of_hire:'',pay_location:'',employer:''
            },
            submitStatus: null,
            permission_edit: false,
            superAdmin: false
        }
    },
    computed: {},
    mounted() {

    },
    validations: {
        formField: {
            first_name: {},
            last_name: {},            
            personal_email: {},
            personal_phone: {},
            residential_address: {},
            middle_name:{}, business_phone:{},business_email:{},residential_city:{},residential_state:{},residential_zipcode:{},
            business_address:{},business_city:{},business_state:{},business_zipcode:{},job_title:{},year_of_birth:{},dob:{},
            retirement_year:{},retired:{},income:{},tcp_saving:{},qualified_saving:{},non_qualified_saving:{},life_insurance:{},facebook:{},linked_in:{},
            twitter:{},other:{},hourly:{},date_of_hire:{},pay_location:{},employer:{}
        }
    },
    async created() {        
        let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
            response.data[0].permission.forEach( function(element) {                
                permissions.push(element.action)
            }.bind(this));
            if(permissions.includes("edit_contact") == true){
                this.getContact();
                this.permission_edit = permissions.includes("edit_contact");
            }else if(response.data[0].role == 'super_admin'){
                this.superAdmin = true;
                this.getContact();
            }else if(permissions.includes("list_contact") == true || permissions.includes("add_contact") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'List Contacts'});
            } else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
        }      
    },
    methods: {
        makeToast(message = '', title = 'Alert', variant = 'warning') 
        {
            this.toastCount++
            this.$root.$bvToast.toast(message, {
                title: title,
                variant: variant,
                autoHideDelay: 3000
            })
        },
        async getContact() 
        {
            let response = await api.post('contact/list', {id: this.$route.params.id});
            if (!response)
                this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)
            if (response.status == 'success') {
                this.formField = {first_name: response.data.first_name , 
                    last_name: response.data.last_name, 
                    personal_email: response.data.personal_email, 
                    personal_phone: response.data.personal_phone, 
                    residential_address: response.data.residential_address,
                    business_phone: response.data.business_phone,
                    middle_name: response.data.middle_name,
                    business_email: response.data.business_email,
                    residential_city: response.data.residential_city,
                    residential_state: response.data.residential_state,
                    residential_zipecode: response.data.residential_zipecode,
                    business_address: response.data.business_address,
                    business_city: response.data.business_city,
                    business_state: response.data.business_state,
                    business_zipecode: response.data.business_zipecode,
                    job_title: response.data.job_title,
                    year_of_birth: response.data.year_of_birth,
                    dob: response.data.dob,
                    retirement_year: response.data.retirement_year,
                    retired: response.data.retired,
                    income: response.data.income,
                    tcp_saving: response.data.tcp_saving,
                    qualified_saving: response.data.qualified_saving,
                    non_qualified_saving: response.data.non_qualified_saving,
                    life_insurance: response.data.life_insurance,
                    facebook: response.data.facebook,
                    linked_in: response.data.linked_in,
                    twitter: response.data.twitter,
                    other: response.data.other,
                    status: response.data.status,
                    date_of_hire: response.data.date_of_hire,
                    pay_location: response.data.pay_location,
                    hourly: response.data.hourly
                };
                
            }else{
                this.makeToast(response.message, 'Alert', 'danger', 6000)
                this.$router.push({name:'List Contacts'});
            }
        },        
        async save() 
        {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR'
            } else {
                this.formField.id = this.$route.params.id;
                let response = await api.post('contact/edit-contact', this.formField);
                if (!response)
                    this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

                if (response.status == 'success') {
                    this.makeToast(response.message, 'Success', 'success', 6000);
                    this.$router.push({name: "List Contacts"});
                } else {
                    for (var error in response.errors) {
                        this.makeToast(response.errors[error], 'Alert', 'danger');
                    }
                }

            }
        }
    }
}


